import { Action } from './Action.js';
/**
 * @class Logout
 * @extends Action
 * @classdesc Действие Завершить сессию
 * Разлогиниться из системы
 * */
export class Logout extends Action {
    execute() {
        const event = new CustomEvent('ms_message');
        event.data = { event: 'logout', username: this._username, password: this.Password };

        if (this.prop_link["error"]) {
            event.data.callback = data => {
                if (data && data.code != 0 && (data.errorText || data.codeDescription))
                    this.prop_link["error"](data.errorText || data.codeDescription);
                else
                    this.prop_link["error"]("");
            }
        }

        window.dispatchEvent(event);
    }

    get Username() {
        return this._username || '';
    }
    set Username(value) {
        this._username = value;
    }

    get Password() {
        return this._password || '';
    }
    set Password(value) {
        this._password = value;
    }

    get Error() {
        return this._error;
    }
    set Error(value) {
        this._error = value;
    }
}